const traverseObject = (obj, excludedKeys, transformerFn) => {
  if (!obj || typeof obj !== "object") {
    return obj;
  }
  if (Array.isArray(obj)) {
    return obj.map(item => traverseObject(item, excludedKeys, transformerFn));
  }

  return Object.keys(obj).reduce((res, key) => {
    if (!excludedKeys.includes(key)) {
      res[transformerFn(key)] = traverseObject(obj[key], excludedKeys, transformerFn);
    } else {
      res[key] = obj[key];
    }

    return res;
  }, {});
};

export const camelize = str =>
  /[-_]/g.test(str) ? str.replace(/[^a-zA-Z0-9]+(.)/g, (m, chr) => chr.toUpperCase()) : str;

/**
 * Converts all object keys from snake_case or kebab-case to camelCase recursively
 * @template T
 * @param {T} obj - The object to transform
 * @param {string[]} [excludedKeys=[]] - Keys to exclude from transformation
 * @returns {T} A new object with all keys transformed to camelCase
 */
export const objNamesToCamelCase = (obj, excludedKeys = []) =>
  traverseObject(obj, excludedKeys, camelize);

export const camelToSnakeCase = str => str.replace(/[A-Z]/g, letter => `_${letter.toLowerCase()}`);

/**
 * Converts all object keys from camelCase to snake_case recursively
 * @template T
 * @param {T} obj - The object to transform
 * @param {string[]} [excludedKeys=[]] - Keys to exclude from transformation
 * @returns {T} A new object with all keys transformed to snake_case
 */
export const objNamesToSnakeCase = (obj, excludedKeys = []) =>
  traverseObject(obj, excludedKeys, camelToSnakeCase);

export default {};
